import React from 'react';
import { Select } from 'semantic-ui-react';

export default Select;
